/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Discover/view.blocks to change it.
import CreditCardDiscover from 'DesignSystem/Svgs/CreditCardDiscover/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Discover({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand/Discover"
  
}) {
  return (<React.Fragment
>
<CreditCardDiscover
  viewPath={`${viewPath}/CreditCardDiscover`}
 width={35}
 marginTop="auto"
 marginBottom="auto"
/>
{children}
</React.Fragment>)
}